import GroupBase from "./GroupsBase";

class ConnectivityGroup extends GroupBase {
    constructor() {
        super({
            name: "Others",
            description: "",
        });
    }
}

export default ConnectivityGroup;
